export { default } from './AppointmentCard';
